import React from "react";
import Meta from "../components/global/meta";
import Four0Four from "../components/404";
import Loader from "../components/global/loader";
import { useForms } from "../hooks/useCms";
import PageComponent from "../components/cms/blocks/pageComponent";
import Post from "./post";
import PressroomArticle from "./pressroomArticle";

export default function Form() {
  const cmsContent = useForms();

  if (cmsContent === undefined) return <Loader withMargins />;
  if (cmsContent === null) return <Four0Four />;

  const blogPosts = cmsContent?.posts;
  const pressroomArticles = cmsContent?.pressroomArticles;

  if (blogPosts?.length) return <Post content={blogPosts.length && blogPosts[0]} />;
  else if (pressroomArticles?.length)
    return <PressroomArticle content={pressroomArticles.length && pressroomArticles[0]} />;
  else
    return (
      <div id="page">
        <Meta title={cmsContent.title} seo={cmsContent.meta?.seo} />
        <div className="centralContainer">
          <PageComponent components={cmsContent.content} />
        </div>
      </div>
    );
}
